module.exports = __webpack_public_path__ + "img/logo21.20d504b2.jpg";